document.addEventListener("DOMContentLoaded", function () {
  class ArchiveFilters extends HTMLElement {
    #namespace = ".t-archive__list";
    #boundHandleFilter;
    #filters = [];
    #pages = null;
    constructor() {
      super();
      this.#boundHandleFilter = this.#handleFilter.bind(this);
      this.elRoot = this.querySelector(this.#namespace);
      this.elTitle = this.querySelector(".c-title");
      this.elResults = this.querySelector(".t-archive__results");
      this.#filters = this.elTitle.querySelectorAll("a");
      for (const filter of this.#filters) {
        filter.addEventListener("click", this.#boundHandleFilter);
      }
    }
    async #handleFilter(event) {
      event.preventDefault();
      const url = this.#refreshUrl(event.target.href);
      const categoryParam = url.searchParams.get("post_tag");
      try {
        const response = await fetch(url.toString());
        const responseBody = await response.json();
        if (!responseBody.success) return;
        this.elResults.innerHTML = responseBody.data;
        for (const filter of this.#filters) {
          filter.removeAttribute("aria-current");
          if (!filter.dataset.value && !categoryParam) {
            filter.setAttribute("aria-current", true);
          }
          if (filter.dataset.value === categoryParam) {
            filter.setAttribute("aria-current", true);
          }
        }
        this.#refreshPagination();
      } catch (error) {
        console.error(error.message);
      }
    }
    #refreshUrl(href) {
      const url = URL.parse(href);
      url.searchParams.set("action", "wiziu_archive_filter");
      if (url.pathname.includes("/page/")) {
        const pathNameParts = url.pathname.split("/page/");
        url.pathname = pathNameParts.shift();
        url.searchParams.set("paged", parseInt(pathNameParts.pop()));
      } else if (!url.searchParams.has("paged")) {
        url.searchParams.set("paged", "1");
      }
      return url;
    }
    #refreshPagination() {
      this.#pages = this.querySelector(".c-pagination")?.querySelectorAll("a") ?? [];
      for (const page of this.#pages) {
        page.addEventListener("click", this.#boundHandleFilter);
      }
    }
  }
  customElements.define("archive-filters", ArchiveFilters);
});